import { useState, useEffect, useRef } from "react";
import { SettingOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Translate } from "../translate";
import FCMManager from "../main/FCMManager";
import Notifications from "./Notifications";
import { getStore, setStore } from "../utils/global";
import custom from "../utils/custom";

const Header = ({ lang, setLang }) => {
  const user = getStore("user");
  const wrapperRef = useRef(null);
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");
  const [visible, setVisible] = useState(0);

  const handleClickOutside = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setVisible(0);
    }
  };

  const handleSettings = () => {
    let hash = window.location.hash;

    if (hash.indexOf("home") !== -1) hash = hash.replace("home", "settings");
    else hash = hash.replace("manage", "settings");
    window.location.hash = hash;
  };

  const changeLang = () => {
    if (getStore("lang") === "en") {
      setStore("lang", "mn");
      setLang("mn");
      window.localStorage.setItem("vsign_lang", "mn");
    } else {
      setStore("lang", "en");
      setLang("en");
      window.localStorage.setItem("vsign_lang", "en");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    const available = ["en", "mn"];
    const storedLang = window.localStorage.getItem("vsign_lang");

    if (!available.includes(storedLang)) {
      setStore("lang", "en");
      setLang("en");
      window.localStorage.setItem("vsign_lang", "en");
    } else {
      setStore("lang", storedLang);
      setLang(storedLang);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setLang]);

  return (
    <div className="header main_header">
      <FCMManager />
      <div className="header_search"></div>
      <div style={{ display: "flex", height: "100%", alignItems: "center", gap: 24 }}>
        <Notifications />
        <Button size="small" type="dashed" onClick={changeLang}>
          {lang}
        </Button>
      </div>
      <div className="header_tooltip_container">
        <div className="header_tooltip flex_center">
          <SettingOutlined onClick={handleSettings} />
        </div>
      </div>
      <div className="user_info" ref={wrapperRef}>
        <div
          className="user_info_container flex_center"
          onClick={() => {
            setVisible(visible === 1 ? 0 : 1);
          }}>
          {user?.profile_image ? <img alt="profile_img" src={user?.profile_image} /> : user?.kdss_name?.[0]}
        </div>
        <div className="user_dropdown" is_show={visible}>
          <div className="user_dropdown_image flex_center">
            {user?.profile_image ? <img alt="profile_img" src={user?.profile_image} /> : user?.kdss_name?.[0]}
          </div>
          <div className="user_dropdown_name">{user?.kdss_name}</div>
          <div className="user_dropdown_mobile">{user?.kdss_msisdn}</div>
          <div className="user_dropdown_email" color="1">
            {user?.kdss_email}
          </div>
          <div
            className="user_dropdown_logout flex_center"
            bg_color="5"
            onClick={() => {
              custom.removeCookie("token");
              window.location.hash = "#/login/mobile";
            }}>
            {Translate[ln].Header.Logout}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
